import * as React from 'react';
import ReactGA from 'react-ga';
import { PropTypes } from 'prop-types';

ReactGA.initialize('UA-129527668-1');

export default class GAListener extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount() {
    if (process.env.NODE_ENV !== 'development') {
      this.sendPageView(this.context.router.history.location);
      this.context.router.history.listen(this.sendPageView);
    }
  }

  sendPageView(location) {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }

  render() {
    return this.props.children;
  }
}
